import { SIZE_COLUMN_FIELD } from "helpers/utils/constants";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { IIdentifierFields, IUPCData, IUPCDataError, UPCRuleType } from "../types";

export class RequiredValuesRule extends Validator<IUPCData[], IUPCDataError> {
    private readonly identifierFields: IIdentifierFields[];
    private readonly sizeField = SIZE_COLUMN_FIELD.key;
    private readonly requiredFields: IIdentifierFields[];

    constructor(requiredFields: IIdentifierFields[], identifierFields: IIdentifierFields[]) {
        super();

        this.requiredFields = requiredFields;
        this.identifierFields = identifierFields;
    }

    validate(model: IUPCData[], errors: IUPCDataError): IUPCDataError {
        const requiredValueErrorType = UPCRuleType.RequiredValuesRule;
        const hasRequiredColumnsError = !!errors[UPCRuleType.RequiredColumnsRule];

        if (hasRequiredColumnsError) {
            return errors;
        }

        const validationErrors = model.reduce((errors, row) => {
            const size = row[this.sizeField]?.value.toString();
            const rowIdentifiers = this.identifierFields.reduce((acc, identifier) => {
                const rowValue = row[identifier.key]?.value;
                if (rowValue) {
                    acc[identifier.key] = rowValue;
                }
                return acc;
            }, {});

            const missingValues = [];

            for (const field of this.requiredFields) {
                const fieldValue = row[field.key]?.value;
                const fieldHasEmptyValue =
                    !row.hasOwnProperty(field.key) ||
                    fieldValue === "" ||
                    fieldValue === undefined ||
                    fieldValue === null;

                if (fieldHasEmptyValue) {
                    missingValues.push(field.display_name);
                }
            }

            const hasMissingValues = missingValues.length > 0;

            if (hasMissingValues) {
                const productIdentifierFields = Object.values(rowIdentifiers).join("-");
                const productSize = size.toUpperCase();
                const errorMessage = formatMessage("|product| |fields| is required and cannot be blank.", {
                    product: `${productIdentifierFields}${productSize ? `-${productSize}` : ""}:`,
                    fields: Array.from(missingValues).join(", "),
                });

                if (errors[requiredValueErrorType]) {
                    errors[requiredValueErrorType].push(errorMessage);
                } else {
                    errors[requiredValueErrorType] = [errorMessage];
                }
            }

            return errors;
        }, errors);

        return super.validate(model, validationErrors);
    }
}
